<template>
  <button class="flex gap-2xs items-center text-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-blurple-300">
    <slot />
  </button>
</template>
